import { Typography } from "@material-ui/core";
import GreenQuote from "assets/web/GreenQuote.svg";
import ReactMarkdown from "components/generics/ReactMarkdown";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    container: {
        width: "95%",
        margin: "0 auto",
        position: "relative",
        // maxHeight: "550px",
        // height: "550px",
    },
    imageContainer: {
        "& img": {
            border: "10px solid #ECF6DF",
            borderRadius: "50%",
            margin: "0 auto",
            bottom: 40,
        }
    },
    quoteContainer: {
        padding: "20px",
        background: "#ECF6DF",
        position: "relative",
        top: "-66.5px",
        zIndex: -1,
        paddingTop: "66.5px",
        borderRadius: "17px",
        height: "440px",

    },
    header: {
        textAlign: "center",
        marginBottom: "20px",
    },
    quote: {
        display: "flex",
        position: "relative",
    },
    quoteIcon: {
        position: "absolute",
    },
    text: {
        marginTop: "10px",
        marginLeft: "5px",
        "& p":{
            margin: 0,
        }
    },
    "@media screen and (max-width:760px)": {
        container: {
            width: "95%",
            height: "550px",
        },
        imageContainer: {},
        quoteContainer: {
            height: "450px",
        },
        header: {},
        quote: {},
    }
})

function CoachCard({
    data,
}) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.imageContainer}>
                <img
                    src={data.image}
                    alt={data.name}
                />
            </div>
            <div className={classes.quoteContainer}>
                <div className={classes.header}>
                    <Typography
                        variant="h5"
                    >
                        {data.name}
                    </Typography>
                    <Typography
                        variant="h5"
                    >
                        {data.designation}
                    </Typography>
                </div>

                <div className={classes.quote}>
                    <div className={classes.quoteIcon}>
                        <GreenQuote />
                    </div>
                    <div className={classes.text}>
                        <ReactMarkdown source={data.quote} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CoachCard;